import { render, staticRenderFns } from "./d-discover-feed.vue?vue&type=template&id=69c2646b&scoped=true&"
import script from "./d-discover-feed.vue?vue&type=script&lang=js&"
export * from "./d-discover-feed.vue?vue&type=script&lang=js&"
import style0 from "./d-discover-feed.vue?vue&type=style&index=0&id=69c2646b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c2646b",
  null
  
)

export default component.exports